import React from 'react'

const Getintouch = () => {
  return (
    <>
        <div className="container mt-5 pt-5">
        <div className="text-center">
          <p className="fs-1">GET IN TOUCH</p>
          <p>VertoX (Incubated At)</p>
          <p>VIT - Technology Business Incubator,</p>
          <p>Vellore Institute of Technology,</p>
          <p>Vellore – 632 014, Tamil Nadu, India.</p>
          <a className="text-dark text-deco-none" href="mailto:admin@vertoxlabs.com">
            admin@vertoxlabs.com
          </a>
          {/* <br />
          <div className="col text-center">
            <div className="mt-5 ">
              <a
                className="text-dark"
                href="https://www.linkedin.com/company/vertoxlabs/"
              >
                <i class="mx-1 fa-brands fs-4 fa-linkedin"></i>
              </a>
              <a className="text-dark" href="#">
                <i class="mx-1 fa-brands fs-4 fa-square-facebook"></i>
              </a>
              <a className="text-dark" href="#">
                <i class="mx-1 fa-brands fs-4 fa-square-instagram"></i>
              </a>
              <a className="text-dark" href="https://twitter.com/VertoX_Labs">
                <i class="mx-1 fa-brands fs-4 fa-square-twitter"></i>
              </a>
            </div>
          </div> */}
          <div className="py-5">
            
          </div>
          
        </div>
      </div>
    </>
  )
}

export default Getintouch